import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
let wpUrl = window.cccisd?.env?.wpUrl || 'https://www.pathwaytowellbeing.org'; // eslint-disable-line
if (wpUrl.endsWith('/')) {
    wpUrl = wpUrl.slice(0, -1);
}

export { wpUrl }; // eslint-disable-line

export const publicLinks = [
    {
        label: 'Home',
        url: wpUrl,
        highlight: [wpUrl],
    },
    {
        label: 'Surveys',
        url: '/surveys',
        highlight: ['surveys'],
    },
    {
        label: 'Resources',
        url: '/resources',
        highlight: ['resources'],
    },
    {
        label: 'About Us',
        url: wpUrl + '/about-us',
        highlight: [wpUrl + '/about-us'],
    },
];

const NavBar = ({ className, noLogoLink }) => {
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'primaryNav').nav;
    } catch (e) {
        // meh, leave it empty
    }

    primaryNavLinks = [...publicLinks, ...primaryNavLinks];

    return (
        <Header
            containerClassName={className}
            isDarkPrimaryNav
            logoClassName={style.logo}
            {...(noLogoLink ? { logoLink: null } : { logoLink: wpUrl })}
            showAlertAction={false}
            showHomeAction={false}
            primaryNavLinks={primaryNavLinks}
            wrapperClassName={style.bg}
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
    noLogoLink: false,
};

NavBar.propTypes = {
    className: PropTypes.string,
    noLogoLink: PropTypes.bool,
};

export default NavBar;
